export default __webpack_public_path__ + "0f710591d65499ad3185f0d5709a855b.svg";